(() => {
	document.addEventListener('DOMContentLoaded', () => {
		let faqs = document.querySelectorAll('.workshop-content-wrap .faq .question');
        faqs.forEach(item => {
          item.addEventListener('click', () => {
			item.parentNode.classList.toggle('expanded');
          });
        })

	});

})()